import React from "react";
import Navbar from "../../Shared/NavBar/Navbar";
import PricingMainContent from "./Components/PricingMainContent";

const Pricing = () => {
  return (
    <div className=" main-wrapper">
      <Navbar />
      <PricingMainContent />
    </div>
  );
};

export default Pricing;
